import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Standard indigo spinner. Replaces the scattered hand-rolled CSS spinners
 * (border-blue/purple) and bare <Loader2> usages so loading is one color/shape.
 */
const Spinner = ({ size = 24, className = '' }) => (
  <Loader2 size={size} className={`animate-spin text-indigo-700 ${className}`} />
);

export default Spinner;
